var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9994,
    cy: 18.0003,
    r: 14.8333,
    fill: "#D9D9D9",
    stroke: "black",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9404 9.06468V26.3361H12.0604V9.06468H23.9404ZM23.9404 8.40039H12.0604C11.6974 8.40039 11.4004 8.69932 11.4004 9.06468V26.3361C11.4004 26.7015 11.6974 27.0004 12.0604 27.0004H23.9404C24.3034 27.0004 24.6004 26.7015 24.6004 26.3361V9.06468C24.6004 8.69932 24.3034 8.40039 23.9404 8.40039ZM21.3004 11.7218V13.0504H14.7004V11.7218H21.3004ZM21.9604 11.0575H14.0404V13.7147H21.9604V11.0575ZM15.3604 16.3718H14.0404V17.0361H15.3604V16.3718ZM18.6604 16.3718H17.3404V17.0361H18.6604V16.3718ZM21.9604 16.3718H20.6404V17.0361H21.9604V16.3718ZM15.3604 19.6932H14.0404V20.3575H15.3604V19.6932ZM18.6604 19.6932H17.3404V20.3575H18.6604V19.6932ZM21.9604 19.6932H20.6404V20.3575H21.9604V19.6932ZM15.3604 23.0147H14.0404V23.679H15.3604V23.0147ZM18.6604 23.0147H17.3404V23.679H18.6604V23.0147ZM21.9604 23.0147H20.6404V23.679H21.9604V23.0147Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.6881e231af6f4d471fefa313e7e8bf4b.svg";
export { ForwardRef as ReactComponent };